import "../stylesheets/ui.css"
import { application } from "../controllers/application"
import UiThemeController from "../controllers/ui_theme_controller"
import UiStageController from "../controllers/ui_stage_controller"
import UiColorsController from "../controllers/ui_colors_controller"
import UiCustomizerController from "../controllers/ui_customizer_controller"
import UiCodeTabsController from "../controllers/ui_code_tabs_controller"
import UiFullscreenController from "../controllers/ui_fullscreen_controller"
import UiVariantsController from "../controllers/ui_variants_controller"

application.register("ui-theme", UiThemeController)
application.register("ui-stage", UiStageController)
application.register("ui-colors", UiColorsController)
application.register("ui-customizer", UiCustomizerController)
application.register("ui-code-tabs", UiCodeTabsController)
application.register("ui-fullscreen", UiFullscreenController)
application.register("ui-variants", UiVariantsController)
